import 'assets/common.js'
import HarleyEvent from 'assets/lib/harley_event/index.js'
import 'assets/lib/harley_event_store.js'

document.addEventListener('DOMContentLoaded', () => {
  HarleyEvent.initialize()
})
